module.exports = __webpack_public_path__ + "static/media/ecp.b6fd845f.svg";